import styled from "styled-components";

export default styled.div`
  max-width: 600px;
  margin: 2em 2em 2em 1em;
  font-weight: 500;
  border-left: 3px solid #808080;
  padding-left: 1em;
`;
